import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import { BackupRuns } from "@/components/backup/BackupRuns";
import { ImportProject, TrashList } from "@/components/backup/TrashImport";
import { AuditLog } from "@/components/backup/AuditLog";
import TenantBackups from "@/components/backup/TenantBackups";
import { FullDbBackup } from "@/components/backup/FullDbBackup";

function Card({ title, desc, children, testid }) {
  return (
    <section className="bg-white border border-slate-200 rounded-xl p-6" data-testid={testid}>
      <h2 className="text-base font-semibold text-slate-900">{title}</h2>
      {desc && <p className="mt-1 text-sm text-slate-500">{desc}</p>}
      <div className="mt-4">{children}</div>
    </section>
  );
}

export default function Backup() {
  const [tick, setTick] = useState(0);
  const navigate = useNavigate();
  const refresh = () => setTick((t) => t + 1);
  return (
    <AppShell>
      <div className="px-5 sm:px-8 lg:px-12 py-8 lg:py-12 max-w-6xl space-y-6" data-testid="backup-page">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-sky-700 font-medium">Protezione dei dati</p>
          <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Backup e sicurezza</h1>
        </div>
        <Card title="Backup completo database" testid="full-db-backup-card"><FullDbBackup /></Card>
        <Card title="Backup automatici" testid="backup-card"><BackupRuns onRestored={refresh} /></Card>
        <Card title="Backup aziende (CRM, prenotazioni, ordini, moduli, membri, file)" desc="Dati dei clienti, cifrati. Ripristino per singola azienda o area, con anteprima, conferma e salvataggio preventivo." testid="tenant-backup-card"><TenantBackups /></Card>
        <Card title="Importa progetto" desc="Carica un file esportato da MUSORA (ZIP con asset) o un backup giornaliero (.json.gz): viene sempre creato un nuovo progetto indipendente." testid="import-card">
          <ImportProject onImported={(p) => { refresh(); navigate(`/projects/${p.id}`); }} />
        </Card>
        <Card title="Cestino" desc="I progetti eliminati restano recuperabili per 30 giorni, poi vengono cancellati automaticamente." testid="trash-card"><TrashList refreshKey={tick} onChanged={refresh} /></Card>
        <Card title="Registro attività" desc="Operazioni rilevanti eseguite nell'app (creazioni, eliminazioni, ripristini, impostazioni, AI)." testid="audit-card"><AuditLog refreshKey={tick} /></Card>
      </div>
    </AppShell>
  );
}
